/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Adr_Tempo_BpmInputs */

const en_options_adr_tempo_bpm = /** @type {(inputs: Options_Adr_Tempo_BpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo / BPM`)
};

const fr_options_adr_tempo_bpm = /** @type {(inputs: Options_Adr_Tempo_BpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo / BPM`)
};

const de_options_adr_tempo_bpm = /** @type {(inputs: Options_Adr_Tempo_BpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo / BPM`)
};

const it_options_adr_tempo_bpm = /** @type {(inputs: Options_Adr_Tempo_BpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo / BPM`)
};

const ru_options_adr_tempo_bpm = /** @type {(inputs: Options_Adr_Tempo_BpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Темп / BPM`)
};

const es_options_adr_tempo_bpm = /** @type {(inputs: Options_Adr_Tempo_BpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo / BPM`)
};

const zh_cn2_options_adr_tempo_bpm = /** @type {(inputs: Options_Adr_Tempo_BpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`速度/BPM`)
};

const ja_options_adr_tempo_bpm = /** @type {(inputs: Options_Adr_Tempo_BpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テンポ/BPM`)
};

const hi_options_adr_tempo_bpm = /** @type {(inputs: Options_Adr_Tempo_BpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`गति / बीपीएम`)
};

const pt_pt2_options_adr_tempo_bpm = /** @type {(inputs: Options_Adr_Tempo_BpmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo / BPM`)
};

/**
* | output |
* | --- |
* | "Tempo / BPM" |
*
* @param {Options_Adr_Tempo_BpmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_adr_tempo_bpm = /** @type {((inputs?: Options_Adr_Tempo_BpmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Adr_Tempo_BpmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_adr_tempo_bpm(inputs)
	if (locale === "de") return de_options_adr_tempo_bpm(inputs)
	if (locale === "it") return it_options_adr_tempo_bpm(inputs)
	if (locale === "ru") return ru_options_adr_tempo_bpm(inputs)
	if (locale === "es") return es_options_adr_tempo_bpm(inputs)
	if (locale === "zh-CN") return zh_cn2_options_adr_tempo_bpm(inputs)
	if (locale === "ja") return ja_options_adr_tempo_bpm(inputs)
	if (locale === "hi") return hi_options_adr_tempo_bpm(inputs)
	if (locale === "pt-PT") return pt_pt2_options_adr_tempo_bpm(inputs)
	return en_options_adr_tempo_bpm(inputs)
});